import {Box, Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel,} from '@material-ui/core';
import Required from './Required';
import {useState} from 'react';
import {EditableInput, EditButton} from './index';
import getTranslated from '../locale/getTranslated';
import {FormattedMessage} from "react-intl";
import messages from "@super-template/messages";
import {Controller} from "react-hook-form";
import ReactHtmlParser from 'react-html-parser';

export default ({name, isAdmin, control, fieldOptions = {}, required, locale, validate}) => {
  const [editing, setEditing] = useState(false);
  const description = getTranslated(fieldOptions.description, locale, true);
  const title = getTranslated(fieldOptions.title, locale);

  return editing ? <EditableInput fieldOptions={fieldOptions} close={() => setEditing(false)} id={name}/> :
    <Controller
      control={control} name={name} defaultValue={''} rules={isAdmin ? {} : {...validate, required}}
      render={({fieldState: {error}, field: {ref, ...field}}) =>
        <FormControl error={!!error} component="fieldset" disabled={isAdmin}>
          <Box display="flex" justifyContent="space-between">
            <FormControlLabel
              style={{padding: '9px 0'}}
              control={<Checkbox checked={!!field.value} {...field} inputRef={ref} style={{marginBottom: 'auto'}} color="primary"/>}
              label={
                <>
                  <FormLabel component="legend">
                    <b>{title}{required && <Required/>}</b>
                  </FormLabel>
                  {description &&
                  <FormHelperText component="div" className={'description'} id={`${name}_description`}>
                    {ReactHtmlParser(description)}
                  </FormHelperText>}
                  {error && <FormHelperText><FormattedMessage {...messages[error.type]}/></FormHelperText>}
                </>
              }/>
            {isAdmin && <EditButton onClick={() => setEditing(true)}/>}
          </Box>
        </FormControl>}
    />
};
